export interface PromoPriceSource {
  wellKnownAttributes?: { Price?: number }
  promoPrice?: null | number
  hasCartPromo?: boolean
  hasCashbackPromo?: boolean
  /** Эффективный размер скидки, целые % (спека промо §14.4, C-20); null — без акционной цены. */
  promoDiscountPercent?: null | number
  /** Сумма кэшбэка бонусами за единицу, ₽. */
  promoCashbackAmount?: null | number
  /** Эффективный размер кэшбэка, целые % от цены к оплате. */
  promoCashbackPercent?: null | number
}

export interface PromoCashback {
  amount: number
  percent: number | null
}

export function getBasePrice(item: PromoPriceSource): number {
  return item.wellKnownAttributes?.Price ?? 0
}

export function getCatalogPromoPrice(item: PromoPriceSource): number | null {
  return item.promoPrice ?? null
}

export function hasVisualDiscount(
  basePrice: number,
  promoPrice: number | null | undefined,
): boolean {
  return promoPrice != null && promoPrice < basePrice
}

export function getEffectiveCatalogPrice(item: PromoPriceSource): number {
  const base = getBasePrice(item)
  const promo = getCatalogPromoPrice(item)
  return hasVisualDiscount(base, promo) ? promo! : base
}

export function hasCartPromoOnly(item: PromoPriceSource): boolean {
  return Boolean(item.hasCartPromo) && !hasVisualDiscount(
    getBasePrice(item),
    getCatalogPromoPrice(item),
  )
}

/**
 * Процент скидки для показа рядом с ценой: из поля контракта, а для ответов без него —
 * из пары цен (то же округление до целого, что на бэкенде). Только при видимой скидке.
 */
export function getDiscountPercent(item: PromoPriceSource): number | null {
  const base = getBasePrice(item)
  const promo = getCatalogPromoPrice(item)
  if (!hasVisualDiscount(base, promo)) return null
  if (item.promoDiscountPercent != null && item.promoDiscountPercent > 0) {
    return item.promoDiscountPercent
  }
  return computeDiscountPercent(base, promo!)
}

/** Процент скидки из пары цен (корзина: цена за единицу после расчёта). */
export function computeDiscountPercent(basePrice: number, finalPrice: number): number | null {
  if (basePrice <= 0 || finalPrice >= basePrice) return null
  const percent = Math.round((1 - finalPrice / basePrice) * 100)
  return percent > 0 ? percent : null
}

/** Кэшбэк акции для карточки; вычислить на клиенте нельзя — только из контракта. */
export function getCashback(item: PromoPriceSource): PromoCashback | null {
  if (!item.hasCashbackPromo) return null
  const amount = item.promoCashbackAmount
  if (amount == null || amount <= 0) return null
  return { amount, percent: item.promoCashbackPercent ?? null }
}

/** «−20%» с типографским минусом (U+2212); $f.percent не подходит — умножает на 100. */
export function formatDiscountPercent(percent: number): string {
  return `−${percent}%`
}
